<template>
  <div>
    <PageAllow controller="ShopCostAnalyze" action="view" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t("ShopCostMonthlyAnalyze.title", [
                  costAnalyze.shop_code,
                  costAnalyze.shop_name,
                  $datetimeUtils.formatTime(costAnalyze.created),
                ])
              }}
              <!-- <span class="body-2">
                {{
                  $t("ShopCostMonthlyAnalyze.time", [
                    $datetimeUtils.formatTime(costAnalyze.created),
                    $datetimeUtils.formatTime(costAnalyze.business_start_date),
                    $datetimeUtils.formatTime(costAnalyze.business_end_date),
                  ])
                }}
              </span> -->
            </v-card-title>
          </v-expansion-panel-header>
          <v-divider />

          <v-expansion-panel-content>
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="6">
                <v-card class="pa-2" outlined tile>
                  <span class="secondary--text text-end">
                    {{ $t("ShopCostMonthlyAnalyze.sale_volume")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{ costAnalyze.sale_volume | formatMoney }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ShopCostMonthlyAnalyze.actual_sale_volume")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{ costAnalyze.actual_sale_volume | formatMoney }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ShopCostMonthlyAnalyze.theory_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{ costAnalyze.theory_price | formatMoney }}
                  </span>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("ShopCostMonthlyAnalyze.actual_price")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money")
                    }}{{ costAnalyze.actual_price | formatMoney }}
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        :headers="detailsHeaders"
        :items="costAnalyzeDetails"
        multi-sort
        disable-pagination
        hide-default-footer
        :no-data-text="$t('ShopCostMonthlyAnalyze.DetailFields.DetailNoData')"
        class="elevation-2 px-4 mt-4"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("ShopCostMonthlyAnalyze.DetailFields.details") }}
            </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-divider />
        </template>

        <!-- 菜品名称 / 商品名称 -->
        <!-- <template v-slot:item.food_name="{ item }">
          <a
            class="text-no-wrap"
            @click.stop="
              foodDetailsDialog = true;
              costAnalyzeFoodDetails = JSON.parse(
                JSON.stringify(item.cost_analyze_food_details)
              );
            "
            v-if="item.food_id"
          >
            {{ item.food_name }}
          </a>
          <span v-else>
            {{ item.material_name }}
          </span>
        </template> -->
        <template v-slot:item.material.standard_name="{ item }">
          <span v-if="item.material && item.material.standard_name && item.material.standard_name.length > 12" :title="item.material.standard_name" style="cursor: pointer">
            {{ item.material.standard_name.slice(0, 12) + "......" }}
          </span>
          <span v-else>
            {{ item.material.standard_name }}
          </span>
        </template>
        <!-- 理论成本数量 / 金额 -->
        <template v-slot:item.theory_num="{ item }">
          {{ $numberFormatter.formatWithDotNoMoreThan(item.theory_num, 6, true)
          }}{{ item.unit }}
          /
          {{ $t("Global.money") }}{{ item.theory_total_price | formatMoney }}
        </template>
        <!-- 实际成本数量 / 金额 -->
        <template v-slot:item.actual_num="{ item }">
          {{ $numberFormatter.formatWithDotNoMoreThan(item.actual_num, 6, true)
          }}{{ item.unit }}
          /
          {{ $t("Global.money") }}{{ item.actual_total_price | formatMoney }}
        </template>
        <!-- 差异量 / 金额 -->
        <template v-slot:item.loss_num="{ item }">
          {{
            $numberFormatter.formatWithDotNoMoreThan(
              item.actual_num - item.theory_num,
              6,
              true
            )
          }}{{ item.unit }}
          /
          {{ $t("Global.money")
          }}{{
            (item.actual_total_price - item.theory_total_price) | formatMoney
          }}
        </template>
        <!-- 差异率 -->
        <template v-slot:item.loss_rate="{ item }">
          {{
            ((item.theory_num == 0
              ? 0
              : (item.actual_num - item.theory_num) / item.theory_num) *
              100)
              | formatTwoDot(true)
          }}{{ $t("Global.rate") }}
        </template>
      </v-data-table>
    </v-sheet>
    <!-- <v-dialog v-model="foodDetailsDialog" max-width="800px">
      <v-card height="400px">
        <v-card-text>
          <v-container>
            <v-data-table
              :headers="foodDetailsHeaders"
              :items="costAnalyzeFoodDetails"
              multi-sort
              disable-pagination
              hide-default-footer
              :no-data-text="
                $t('ShopCostMonthlyAnalyze.DetailFields.DetailNoData')
              "
            >
              <template v-slot:item.material_unit>
                {{ $t("Global.gram") }}
              </template>

              <template v-slot:item.theory_num="{ item }">
                {{ item.theory_gross_weight | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{ item.theory_total_price | formatMoney }}
              </template>

              <template v-slot:item.actual_num="{ item }">
                {{ item.actual_gross_weight | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{ item.actual_total_price | formatMoney }}
              </template>

              <template v-slot:item.loss_num="{ item }">
                {{
                  (item.actual_gross_weight - item.theory_gross_weight)
                    | formatTwoDot(true)
                }}{{ $t("Global.gram") }}
                /
                {{ $t("Global.money")
                }}{{
                  (item.actual_total_price - item.theory_total_price)
                    | formatMoney
                }}
              </template>

              <template v-slot:item.loss_rate="{ item }">
                {{
                  ((item.theory_num == 0
                    ? 0
                    : (item.actual_num - item.theory_num) / item.theory_num) *
                    100)
                    | formatTwoDot(true)
                }}{{ $t("Global.rate") }}
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import shopCostAnalyze from "@/api/shop_cost_analyze";
import consts from "@/consts";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  data: () => ({
    panels: [0],
    costAnalyze: {},
    costAnalyzeDetails: [],
    // foodDetailsDialog: false,
    // costAnalyzeFoodDetails: [],
  }),
  mounted() {
    this.getCostAnalyzeFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopCostAnalyze", [consts.shopName()]),
          disabled: false,
          href: "/shop-cost-analyze",
        },
        {
          text:
            this.costAnalyze &&
            this.costAnalyze.shop_code &&
            this.costAnalyze.shop_name
              ? i18n.t("ShopCostMonthlyAnalyze.shopName", [
                  this.costAnalyze.shop_code,
                  this.costAnalyze.shop_name,
                ])
              : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    detailsHeaders: () => [
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.material_code"),
        align: "start",
        value: "material_code",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.material_name"),
        align: "start",
        value: "material_name",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.category_name"),
        align: "start",
        sortable: false,
        value: "category_name",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.unit"),
        align: "start",
        value: "unit",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.standard_name"),
        align: "start",
        value: "material.standard_name",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.theory_num"),
        align: "start",
        value: "theory_num",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.actual_num"),
        align: "start",
        value: "actual_num",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.loss_num"),
        align: "start",
        value: "loss_num",
        class: "caption",
        cellClass: "caption",
      },
      {
        text: i18n.t("materialAnalyze.Fields.loss_rate"),
        align: "start",
        sortable: false,
        value: "loss_rate",
        class: "caption",
        cellClass: "caption",
      },
    ],
    // foodDetailsHeaders() {
    //   var headers = [
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.material_code"),
    //       align: "start",
    //       value: "material_code",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.material_name"),
    //       align: "start",
    //       value: "material_name",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.material_unit"),
    //       align: "start",
    //       value: "material_unit",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.theory_num"),
    //       align: "start",
    //       value: "theory_num",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.actual_num"),
    //       align: "start",
    //       value: "actual_num",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.loss_num"),
    //       align: "start",
    //       value: "loss_num",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //     {
    //       text: i18n.t("ShopCostMonthlyAnalyze.DetailFields.rate"),
    //       align: "start",
    //       value: "rate",
    //       class: "caption",
    //       cellClass: "caption",
    //     },
    //   ];
    //   return headers;
    // },
  },
  methods: {
    getCostAnalyzeFromAPI() {
      shopCostAnalyze.fetchOne(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.costAnalyze = response.data.cost_analyze;
            this.costAnalyzeDetails =
              response.data.cost_analyze.cost_analyze_details;
          }
        }.bind(this)
      );
    },
  },
  watch: {
    shopDailyReport: {
      handler() {
        // console.log(this.shopDailyReport);
      },
    },
    costAnalyzeDetails: {
      handler() {
        // console.log(this.costAnalyzeDetails);
      },
    },
  },
};
</script>
